import Vue from 'vue';
import VueRouter from 'vue-router';
import VueResource from 'vue-resource';
import routes from './routers';
import store from './store'
import vueLoadingBar from 'vueLoadingBar';
import titleComponent from './components/dynamicTitle.vue';
import WKheader from './components/WKheader.vue'
import { Field, Button, Actionsheet, Toast, InfiniteScroll, Lazyload} from 'mint-ui';
import {initUser, initFileBaseUrl, goLogin } from './libAndUtils/utils';
import VueClipboards from 'vue-clipboards';

// import 'vconsole/dist/vconsole.min';

import './assets/mint-style.css';
import './assets/reset.css';
import './assets/common.css';
import './assets/loadingbar.css';



Vue.use(VueRouter);
Vue.use(VueResource);
Vue.use(vueLoadingBar);
Vue.use(InfiniteScroll);
Vue.use(Lazyload);
Vue.use(VueClipboards);

Vue.component('dy-title', titleComponent);
Vue.component('WKheader', WKheader);
Vue.component(Field.name, Field);
Vue.component(Button.name, Button);
Vue.component(Actionsheet.name, Actionsheet);

const eventHub = new Vue();// Single event hub
// Distribute to components using global mixin

Vue.mixin({
  data() {
    return {
      eventHub,
    };
  },
});

const EventBus = new Vue();

const router = new VueRouter({
  mode: 'history',
  routes
});

Vue.http.interceptors.push(function (request, next) {
  if (request.url.indexOf('/jlf/') > -1) {
    if (localStorage.getItem('deviceUUID')) {
      request.headers.set('DeviceUuid', localStorage.getItem('deviceUUID'));
    }
    if (JSON.parse(localStorage.getItem('user')) && (JSON.parse(localStorage.getItem('user')).AuthorizationToken || JSON.parse(localStorage.getItem('user')).token)) {
      request.headers.set('Authorization', 'Token ' + (JSON.parse(localStorage.getItem('user')).AuthorizationToken || JSON.parse(localStorage.getItem('user')).token));
    }
  }
  console.log('---------Request ' + request.method + Vue.url(request.url, request.params) + '---------------');
  console.log(request.body);
  console.log('--------------------------------------------------------------------');
  next(function (res) {
    console.log('=========Response ' + request.method + Vue.url(request.url, request.params) + '==========');
    console.log(res.body);
    console.log('==================================================================');

    if (!res.ok) {
      switch (res.status) {
        case 0:
          Toast({message: '请求超时', position: 'top'});
          return {...res, ok: true};
        case 401:
          Toast({message: '没有授权', position: 'top'});
          return {...res, ok: true};
        case 403:
          Toast({message: '没有权限', position: 'top'});
          // reOauthUser(router.path || router.history.current.fullPath);
          // goLogin();
          return {...res, ok: true};
        default :
          if (res.body.error && res.body.error.indexOf('block 0') > -1) {
            if (store.state.uploadFile.uploadFail === false) {
              console.log('begin reUpload...');
              store.dispatch('UPLOAD_FAIL', true);
              EventBus.eventHub.$emit('UPLOAD_FAIL', true);
              console.log(store.state.uploadFile.uploadFail)
            }
          }
          else {
            Toast({message: res.body.errmsg, position: 'top'});
          }
          return {...res, ok: true}
      }
    }
    if (res.body.errcode && res.body.errcode !== 0) {
      Toast({message: res.body.errmsg, position: 'top'});
    }
    return {...res.body, ok: true}
  }.bind(this));
}.bind(this));

// router.beforeEach((to, from, next) => {
//   if (to.fullPath.indexOf('meetingsH5') > -1 || to.fullPath.indexOf('addMeeting') > -1) {
//     next()
//   }
//   else {
//     initUser();
//     initFileBaseUrl();
//     console.log(from.fullPath, to.fullPath, to);
//     if (to.fullPath.indexOf('clickFarming') > -1 || to.fullPath.indexOf('login') > -1 || to.fullPath.indexOf('favicon.ico') > -1) {
//       next()
//     }
//     else {
//       if ((!JSON.parse(localStorage.getItem('user')) || JSON.parse(localStorage.getItem('user')).anonymous) && to.name !== 'login') { // 判断是否已经登录且前往的页面不是登录页
//         next({
//           name: 'login'
//         });
//       }
//       else {
//         next()
//       }
//     }
//   }
// });

const app = new Vue({
  router,
  store
}).$mount('#app');

app.loadingBarDelay = 100;



// WEBPACK FOOTER //
// ./src/main.js